(function () {
  "use strict";

  // Reads website cookie and pixel consent only; patient communications consent is managed separately.
  var STORAGE_KEY = "drsknn_attribution_v1";
  var COOKIE_KEY = "drsknn_attribution";
  var VISITOR_KEY = "drsknn_visitor_id";
  var SESSION_KEY = "drsknn_session_id";
  var SESSION_STARTED_KEY = "drsknn_session_started_at";
  var ATTR_KEYS = [
    "gclid",
    "gbraid",
    "wbraid",
    "ttclid",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "fbclid",
    "fbp",
    "fbc",
    "campaign",
    "asset_variant",
    "funnel_stage",
    "landing_source",
    "origin_role"
  ];
  var TARGET_HOSTS = [
    "drsknn.uk",
    "www.drsknn.uk",
    "drsknn-explorer-rs8d.onrender.com",
    "drsknn-explorer-rs8d-rs8d.onrender.com",
    "partner.pabau.com",
    "connect.pabau.com",
    "skinxs.com",
    "www.skinxs.com"
  ];
  var BOOKING_CONSULTATION_URL = "https://www.drsknn.uk/kiosk?tab=consultations";
  var BOOKING_TREATMENTS_URL = "https://www.drsknn.uk/kiosk?tab=treatments";
  var LEGACY_BOOKING_RE = /(connect-uk1\.pabau\.me\/bookings\.php|connect\.pabau\.com\/bookings\.php|partner\.pabau\.com\/online-bookings|www\.drsknn\.com\/kiosk\?(consultations|treatments)|drsknn\.uk\/kiosk\?treatments|drsknn\.online\/(?:pages\/)?book)/i;
  var LEGACY_BOOKING_URL_RE = /https?:\/\/(?:connect-uk1\.pabau\.me\/bookings\.php|connect\.pabau\.com\/bookings\.php|partner\.pabau\.com\/online-bookings\/drsknn)[^'"\s<)]*|https?:\/\/(?:www\.)?drsknn\.com\/kiosk\?(?:consultations|treatments)|https?:\/\/(?:www\.)?drsknn\.uk\/kiosk\?treatments|https?:\/\/(?:www\.)?drsknn\.online\/(?:pages\/)?book/gi;
  var FAMILY_ALIASES = [
    ["hydrafacial", ["hydrafacial", "hydra facial"]],
    ["injectables", ["botox", "injectable", "anti wrinkle", "anti-wrinkle", "filler", "profhilo", "polynucleotide"]],
    ["skin_boosters", ["skin booster", "skinboosters", "seventy hyal", "sunekos"]],
    ["acne", ["acne", "blemish", "breakout"]],
    ["pigmentation", ["pigmentation", "melasma", "dark spot", "hyperpigmentation"]],
    ["laser", ["laser", "ipl", "resurfacing"]],
    ["consultation", ["consultation", "consult", "skin scan", "appointment"]],
    ["skincare", ["skincare", "cream", "cleanser", "serum", "universkin"]]
  ];

  var state = {
    maxScroll: 0,
    clickCount: 0,
    startedAt: Date.now(),
    engagementSent: false,
    lastPageKey: "",
    lastActionKey: "",
    lastActionAt: 0,
    scrollMilestones: {},
    viewedSections: {},
    clickBurst: [],
    sectionObserver: null
  };

  function currentScript() {
    return document.currentScript || (function () {
      var scripts = document.getElementsByTagName("script");
      return scripts[scripts.length - 1] || null;
    })();
  }

  var script = currentScript();
  var dataset = script && script.dataset ? script.dataset : {};
  var config = {
    eventUrl: dataset.drsknnEventUrl || window.DRSKNN_BROWSER_EVENT_URL || "",
    publicToken: dataset.drsknnPublicToken || window.DRSKNN_BROWSER_EVENT_TOKEN || "",
    sourceProperty: dataset.drsknnSourceProperty || window.location.hostname,
    googleEvents: dataset.drsknnGoogleEvents !== "false",
    metaEvents: dataset.drsknnMetaEvents !== "false",
    adIntentDetail: dataset.drsknnAdIntentDetail === "true",
    cartAttributes: dataset.drsknnCartAttributes !== "false"
  };

  function isObject(value) {
    return value && typeof value === "object" && !Array.isArray(value);
  }

  function clean(value, maxLen) {
    if (value == null) return "";
    var text = String(value).replace(/[\r\n\t]/g, " ").replace(/\s+/g, " ").trim();
    if (!text) return "";
    return text.slice(0, maxLen || 255);
  }

  function readCookie(name) {
    try {
      var prefix = encodeURIComponent(name) + "=";
      var parts = document.cookie ? document.cookie.split(";") : [];
      for (var i = 0; i < parts.length; i += 1) {
        var part = parts[i].trim();
        if (part.indexOf(prefix) === 0) {
          return decodeURIComponent(part.slice(prefix.length));
        }
      }
    } catch (e) {}
    return "";
  }

  function writeCookie(name, value, maxAgeSeconds) {
    try {
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value)
        + "; Max-Age=" + (maxAgeSeconds || 60 * 60 * 24 * 90)
        + "; Path=/; SameSite=Lax" + secure;
    } catch (e) {}
  }

  function randomId(prefix) {
    var raw = "";
    try {
      var arr = new Uint8Array(16);
      window.crypto.getRandomValues(arr);
      raw = Array.prototype.map.call(arr, function (n) {
        return ("0" + n.toString(16)).slice(-2);
      }).join("");
    } catch (e) {
      raw = String(Date.now()) + String(Math.random()).slice(2);
    }
    return prefix + "_" + raw;
  }

  function readStoredJson(storageKey, cookieKey) {
    try {
      var raw = window.localStorage && window.localStorage.getItem(storageKey);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (isObject(parsed)) return parsed;
      }
    } catch (e) {}
    try {
      var cookie = readCookie(cookieKey);
      if (cookie) {
        var cookieParsed = JSON.parse(cookie);
        if (isObject(cookieParsed)) return cookieParsed;
      }
    } catch (e) {}
    return {};
  }

  function writeStoredJson(storageKey, cookieKey, data) {
    var payload = JSON.stringify(data);
    try {
      if (window.localStorage) window.localStorage.setItem(storageKey, payload);
    } catch (e) {}
    writeCookie(cookieKey, payload, 60 * 60 * 24 * 90);
  }

  function readStored() {
    var record = readStoredJson(STORAGE_KEY, COOKIE_KEY);
    var captured = Date.parse(record.captured_at || "");
    var age = Date.now() - captured;
    // The cookie already expires after 90 days; localStorage must obey the same bound.
    if (!isFinite(captured) || age < -300000 || age > 90 * 86400000) return {};
    return record;
  }

  function writeStored(data) {
    writeStoredJson(STORAGE_KEY, COOKIE_KEY, data);
  }

  function stableId(key, prefix, maxAgeSeconds) {
    if (window.DRSKNN_PRIVACY_MODE === "iubenda" && !analyticsAllowed()) return prefix + "_pending";
    var existing = "";
    try {
      existing = window.localStorage && window.localStorage.getItem(key);
    } catch (e) {}
    existing = existing || readCookie(key);
    if (existing) return existing;
    var created = randomId(prefix);
    try {
      if (window.localStorage) window.localStorage.setItem(key, created);
    } catch (e) {}
    writeCookie(key, created, maxAgeSeconds);
    return created;
  }

  function visitorId() {
    return stableId(VISITOR_KEY, "v", 60 * 60 * 24 * 365);
  }

  function sessionId() {
    if (window.DRSKNN_PRIVACY_MODE === "iubenda" && !analyticsAllowed()) return "s_pending";
    var now = Date.now();
    var started = 0;
    try {
      started = Number(window.sessionStorage && window.sessionStorage.getItem(SESSION_STARTED_KEY));
    } catch (e) {}
    if (!started || now - started > 30 * 60 * 1000) {
      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(SESSION_KEY, randomId("s"));
          window.sessionStorage.setItem(SESSION_STARTED_KEY, String(now));
        }
      } catch (e) {}
    }
    try {
      return (window.sessionStorage && window.sessionStorage.getItem(SESSION_KEY)) || stableId(SESSION_KEY, "s", 60 * 60);
    } catch (e) {
      return stableId(SESSION_KEY, "s", 60 * 60);
    }
  }

  function incomingParams() {
    var params = new URLSearchParams(window.location.search || "");
    var out = {};
    ATTR_KEYS.forEach(function (key) {
      var value = clean(params.get(key), 255);
      if (value) out[key] = value;
    });
    return out;
  }

  function captureAttribution() {
    if (!marketingAllowed()) return readStored();
    var existing = readStored();
    var incoming = incomingParams();
    var hasIncoming = Object.keys(incoming).length > 0;
    var hasClickId = Boolean(incoming.gclid || incoming.gbraid || incoming.wbraid || incoming.fbclid || incoming.ttclid || incoming.msclkid || incoming.fbp || incoming.fbc);
    var merged = {};

    Object.keys(existing).forEach(function (key) {
      if (ATTR_KEYS.indexOf(key) !== -1 || key === "captured_at" || key === "landing_url") {
        merged[key] = existing[key];
      }
    });

    if (hasIncoming) {
      ATTR_KEYS.forEach(function (key) {
        if (incoming[key] && (hasClickId || !merged[key])) {
          merged[key] = incoming[key];
        }
      });
      merged.captured_at = new Date().toISOString();
      merged.landing_url = clean(window.location.href, 2000);
      writeStored(merged);
    }

    return merged;
  }

  function consentState() {
    var stateOut = {
      analytics_storage: "unknown",
      marketing_storage: "unknown",
      ad_personalization: "unknown"
    };
    try {
      if (window.DRSKNN_CONSENT_STATE) {
        return {
          analytics_storage: window.DRSKNN_CONSENT_STATE.analytics ? "granted" : "denied",
          marketing_storage: window.DRSKNN_CONSENT_STATE.marketing ? "granted" : "denied",
          ad_personalization: window.DRSKNN_CONSENT_STATE.marketing ? "granted" : "denied"
        };
      }
      if (window.DRSKNN_PRIVACY_MODE === "iubenda") {
        if (!window._iub || !_iub.cs || !_iub.cs.api || typeof _iub.cs.api.getPreferences !== "function") {
          return { analytics_storage: "denied", marketing_storage: "denied", ad_personalization: "denied" };
        }
        var prefs = _iub.cs.api.getPreferences();
        var purposes = prefs && prefs.purposes ? prefs.purposes : {};
        var analytics = purposes["4"] === true || purposes[4] === true;
        var marketing = purposes["5"] === true || purposes[5] === true;
        return {
          analytics_storage: analytics ? "granted" : "denied",
          marketing_storage: marketing ? "granted" : "denied",
          ad_personalization: marketing ? "granted" : "denied"
        };
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        var privacy = window.Shopify.customerPrivacy;
        if (typeof privacy.analyticsProcessingAllowed === "function") {
          stateOut.analytics_storage = privacy.analyticsProcessingAllowed() ? "granted" : "denied";
        }
        if (typeof privacy.marketingAllowed === "function") {
          stateOut.marketing_storage = privacy.marketingAllowed() ? "granted" : "denied";
          stateOut.ad_personalization = privacy.marketingAllowed() ? "granted" : "denied";
        }
      }
    } catch (e) {}
    return stateOut;
  }

  function analyticsAllowed() {
    var consent = consentState();
    if (window.DRSKNN_PRIVACY_MODE === "iubenda") return consent.analytics_storage === "granted";
    return consent.analytics_storage !== "denied";
  }

  function marketingAllowed() {
    var consent = consentState();
    if (window.DRSKNN_PRIVACY_MODE === "iubenda") return consent.marketing_storage === "granted";
    return consent.marketing_storage === "granted" || consent.marketing_storage === "unknown";
  }

  function intentFromText(text, path) {
    var haystack = clean([text, path || window.location.pathname].join(" "), 1000).toLowerCase();
    for (var i = 0; i < FAMILY_ALIASES.length; i += 1) {
      var family = FAMILY_ALIASES[i][0];
      var aliases = FAMILY_ALIASES[i][1];
      for (var j = 0; j < aliases.length; j += 1) {
        if (haystack.indexOf(aliases[j]) !== -1) {
          return { family: family, label: aliases[j], score: 0.7 };
        }
      }
    }
    return {};
  }

  function pageEventType(intent) {
    var path = window.location.pathname.toLowerCase();
    if (path.indexOf("/products/") !== -1) return "product_view";
    if (path.indexOf("/collections/") !== -1) return "service_view";
    if (intent.family && intent.family !== "skincare") return "viewed_treatment";
    return "page_view";
  }

  function pageKey() {
    return [window.location.pathname, window.location.search, window.location.hash, clean(document.title, 120)].join("|");
  }

  function datasetText(element) {
    var output = [];
    try {
      if (!element || !element.dataset) return "";
      Object.keys(element.dataset).forEach(function (key) {
        var lower = key.toLowerCase();
        if (/(email|phone|name|address|postcode|zip|token|secret|password)/.test(lower)) return;
        output.push(key + ":" + clean(element.dataset[key], 120));
      });
    } catch (e) {}
    return output.join(" ");
  }

  function safeFieldName(element) {
    return clean(
      (element && element.getAttribute && (
        element.getAttribute("name")
        || element.getAttribute("id")
        || element.getAttribute("aria-label")
        || element.getAttribute("placeholder")
      )) || "",
      120
    );
  }

  function isSafeIntentField(element) {
    var text = safeFieldName(element).toLowerCase();
    if (!text || /(email|phone|mobile|name|address|postcode|zip|dob|date of birth|password|card)/.test(text)) return false;
    return /(search|query|filter|treatment|service|concern|condition|category|slot|time|date|practitioner|clinic)/.test(text);
  }

  function fieldKind(element) {
    var text = safeFieldName(element).toLowerCase();
    var type = clean(element && element.getAttribute ? element.getAttribute("type") : "", 40).toLowerCase();
    if (/(email|phone|mobile|name|address|postcode|zip|dob|date of birth)/.test(text) || ["email", "tel"].indexOf(type) !== -1) {
      return "contact_details_field";
    }
    if (/(card|payment|cvc|cvv|expiry|password|secret|token)/.test(text) || type === "password") {
      return "payment_or_secret_field";
    }
    if (/(search|query|filter)/.test(text)) return "search_or_filter_field";
    if (/(treatment|service|concern|condition|category)/.test(text)) return "treatment_preference_field";
    if (/(slot|time|date|practitioner|clinic)/.test(text)) return "booking_preference_field";
    return "form_field";
  }

  function elementLabel(element) {
    if (!element || !element.getAttribute) return "";
    var labelledBy = clean(element.getAttribute("aria-labelledby"), 120);
    var labelledText = "";
    try {
      if (labelledBy) {
        labelledText = labelledBy.split(/\s+/).map(function (id) {
          var labelled = document.getElementById(id);
          return labelled ? clean(labelled.textContent, 120) : "";
        }).filter(Boolean).join(" ");
      }
    } catch (e) {}
    return clean(
      element.getAttribute("aria-label")
        || element.getAttribute("title")
        || element.getAttribute("data-treatment-name")
        || element.getAttribute("data-treatment")
        || element.getAttribute("data-service")
        || element.getAttribute("data-practitioner")
        || element.getAttribute("data-practitioner-name")
        || element.getAttribute("data-concern")
        || element.getAttribute("data-condition")
        || labelledText
        || datasetText(element)
        || element.textContent
        || element.value
        || "",
      220
    );
  }

  function classifyInteraction(combined, url, host) {
    var text = clean(combined, 700);
    var isBooking = ["drsknn.uk", "www.drsknn.uk", "partner.pabau.com", "connect.pabau.com"].indexOf(host) !== -1
      || /book|appointment|consult|checkout|pay|stripe|continue|confirm/i.test(text);
    var isTimeslot = /timeslot|time-slot|booking-slot|slot|appointment time|select time|\b\d{1,2}:\d{2}\b/i.test(text);
    var isPractitioner = /practitioner|clinician|doctor|nurse|therapist|provider|team member|consultant|dr\b/i.test(text);
    var isReview = /review|testimonial|rating|stars|trustpilot|google review|before and after|result|case study/i.test(text);
    var looksTreatment = /treatment|service|concern|condition|consultation|hydrafacial|botox|filler|laser|acne|pigment|skin booster|peel|universkin/i.test(text);
    if (isTimeslot) return "selected_timeslot";
    if (isPractitioner) return "practitioner_selected";
    if (isReview) return "review_engagement";
    if (isBooking && /next|continue|confirm|payment|checkout|pay|back|step|slot|time|date/i.test(text)) return "booking_step";
    if (isBooking) return "booking_link_click";
    if (url && host && host !== window.location.hostname.toLowerCase()) return "outbound_link_click";
    if (looksTreatment) return "viewed_treatment";
    return "click";
  }

  function isShopifyStorefrontHost(host) {
    return [
      "drsknn.com",
      "www.drsknn.com",
      "drsknn.store",
      "www.drsknn.store",
      "drsknn.online",
      "www.drsknn.online"
    ].indexOf((host || "").toLowerCase()) !== -1;
  }

  function shouldDecorate(url) {
    var host = (url.hostname || "").toLowerCase();
    return TARGET_HOSTS.some(function (allowed) {
      return host === allowed;
    });
  }

  function decorateUrl(rawUrl) {
    if (!rawUrl || rawUrl.indexOf("mailto:") === 0 || rawUrl.indexOf("tel:") === 0 || rawUrl.indexOf("#") === 0) {
      return rawUrl;
    }
    var url;
    try {
      url = new URL(rawUrl, window.location.href);
    } catch (e) {
      return rawUrl;
    }
    if (!shouldDecorate(url)) return rawUrl;

    var allowMarketing = marketingAllowed();
    var data = allowMarketing ? readStored() : {};
    ATTR_KEYS.forEach(function (key) {
      if (data[key] && !url.searchParams.get(key)) {
        url.searchParams.set(key, data[key]);
      }
    });
    if (allowMarketing) {
      url.searchParams.set("drsknn_visitor_id", visitorId());
      url.searchParams.set("drsknn_session_id", sessionId());
      url.searchParams.set("attribution_source", "drsknn_owned_site");
    }
    if (url.protocol === "https:" && ["drsknn.uk", "www.drsknn.uk"].indexOf(url.hostname) !== -1) {
      var api = window.DRSKNN_GOOGLE_MEASUREMENT;
      var measurement = consentState().analytics_storage === "granted" && api && typeof api.getIdentity === "function" ? api.getIdentity() : {};
      ["ga_client_id", "ga_session_id", "ga_measurement_id", "ga_identity_captured_at"].forEach(function (key) {
        if (measurement[key]) url.searchParams.set(key, measurement[key]);
      });
    }
    return url.toString();
  }

  function isLegacyBookingTarget(value) {
    return Boolean(value && LEGACY_BOOKING_RE.test(String(value)));
  }

  function bookingSignal(element, value) {
    return [
      value || "",
      element && element.textContent ? element.textContent : "",
      element && element.getAttribute ? element.getAttribute("aria-label") || "" : ""
    ].join(" ").toLowerCase();
  }

  function bookingUrlForValue(value, element) {
    var signal = bookingSignal(element, value);
    var hasTreatmentSignal =
      signal.indexOf("tab=treatments") !== -1 ||
      signal.indexOf("?treatments") !== -1 ||
      signal.indexOf("treatment") !== -1 ||
      signal.indexOf("bookings") !== -1 ||
      signal.indexOf("journey") !== -1 ||
      signal.indexOf("explorer") !== -1;
    if (hasTreatmentSignal && signal.indexOf("consult") === -1) {
      return BOOKING_TREATMENTS_URL;
    }
    return BOOKING_CONSULTATION_URL;
  }

  function normalizeBookingText(value, element) {
    if (!value || !isLegacyBookingTarget(value)) return value;
    return String(value).replace(LEGACY_BOOKING_URL_RE, function (match) {
      return bookingUrlForValue(match, element);
    });
  }

  function normalizeBookingElement(element) {
    if (!element || !element.getAttribute || element.hasAttribute("data-drsknn-booking-normalized")) return false;
    var changed = false;
    ["href", "data-href", "data-url"].forEach(function (attr) {
      var value = element.getAttribute(attr);
      if (isLegacyBookingTarget(value)) {
        element.setAttribute(attr, bookingUrlForValue(value, element));
        changed = true;
      }
    });
    var onclick = element.getAttribute("onclick");
    var normalizedOnclick = normalizeBookingText(onclick, element);
    if (normalizedOnclick && normalizedOnclick !== onclick) {
      element.setAttribute("onclick", normalizedOnclick);
      changed = true;
    }
    if (changed) element.setAttribute("data-drsknn-booking-normalized", "true");
    return changed;
  }

  function normalizeBookingLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      if (scope.matches && (scope.matches("a[href], [onclick], [data-href], [data-url]"))) {
        normalizeBookingElement(scope);
      }
      scope.querySelectorAll("a[href], [onclick], [data-href], [data-url]").forEach(normalizeBookingElement);
    } catch (e) {}
  }

  function handleLegacyBookingClick(event, element) {
    try {
      if (!element || !element.getAttribute) return false;
      var target = [
        element.getAttribute("href"),
        element.getAttribute("data-href"),
        element.getAttribute("data-url"),
        element.getAttribute("onclick")
      ].join(" ");
      if (!isLegacyBookingTarget(target) && !((target.indexOf(BOOKING_CONSULTATION_URL) !== -1 || target.indexOf(BOOKING_TREATMENTS_URL) !== -1) && /openPabauModal/i.test(target))) {
        return false;
      }
      normalizeBookingElement(element);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.location.href = bookingUrlForValue(target, element);
      return true;
    } catch (e) {}
    return false;
  }

  function decorateElement(element, attr) {
    try {
      if (!element || element.hasAttribute("data-drsknn-no-attribution")) return;
      var states = decorateElement.states || (decorateElement.states = new WeakMap());
      var previous = states.get(element) || {};
      var current = element.getAttribute(attr);
      var entry = previous[attr];
      // Restore only this helper's prior additions; honour later application href changes.
      var original = entry && current === entry.decorated ? entry.original : current;
      var decorated = decorateUrl(original);
      previous[attr] = { original: original, decorated: decorated };
      states.set(element, previous);
      if (decorated && decorated !== current) element.setAttribute(attr, decorated);
    } catch (e) {}
  }

  function decorateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    try {
      normalizeBookingLinks(scope);
      scope.querySelectorAll("a[href]").forEach(function (link) {
        decorateElement(link, "href");
      });
      scope.querySelectorAll("iframe[src]").forEach(function (frame) {
        decorateElement(frame, "src");
      });
    } catch (e) {}
  }

  function publicEventUrl() {
    if (!config.eventUrl) return "";
    if (!config.publicToken) return "";
    try {
      var url = new URL(config.eventUrl, window.location.href);
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch (e) {
      return config.eventUrl.split(/[?#]/, 1)[0];
    }
  }

  function buildPayload(eventType, extra) {
    extra = extra || {};
    var attribution = readStored();
    var intent = extra.intent || intentFromText(document.title, window.location.pathname);
    return {
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      external_event_id: randomId("evt"),
      source_property: config.sourceProperty,
      page_url: clean(window.location.href, 1024),
      page_title: clean(document.title, 255),
      page_path: clean(window.location.pathname, 512),
      referrer: clean(document.referrer, 1024),
      anonymous_id: visitorId(),
      session_id: sessionId(),
      attribution: attribution,
      consent: consentState(),
      intent: intent,
      element: extra.element || {},
      engagement: extra.engagement || {},
      ecommerce: extra.ecommerce || productContext(),
      meta: {
        fbp: clean(readCookie("_fbp"), 255),
        fbc: clean(readCookie("_fbc"), 255)
      },
      context: {
        user_agent_family: "browser",
        user_agent: clean(window.navigator && window.navigator.userAgent, 512),
        viewport_width: window.innerWidth || 0,
        viewport_height: window.innerHeight || 0,
        source_script: "drsknn-browser-intent-v2"
      }
    };
  }

  function sendToMarketingApp(payload, immediate) {
    if (!config.eventUrl || !config.publicToken || !analyticsAllowed()) return;
    var body = JSON.stringify(payload);
    var url = publicEventUrl();
    try {
      window.fetch(url, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        keepalive: Boolean(immediate),
        headers: {
          "Content-Type": "text/plain",
          "X-DrSknn-Browser-Token": config.publicToken
        },
        body: body
      }).catch(function () {});
    } catch (e) {}
  }

  function productContext() {
    var title = "";
    try {
      var heading = document.querySelector("h1, [data-product-title], .product__title");
      title = heading ? heading.textContent : "";
    } catch (e) {}
    return {
      product_title: clean(title, 255)
    };
  }

  function routeGroup(path) {
    path = clean(path || window.location.pathname, 255).toLowerCase();
    if (path === "/" || path === "") return "home";
    if (path.indexOf("/products/") === 0) return "product";
    if (path.indexOf("/collections/") === 0) return "collection";
    if (path.indexOf("/cart") === 0) return "cart";
    if (path.indexOf("/search") === 0) return "search";
    if (path.indexOf("/account") === 0) return "account";
    if (path.indexOf("/checkout") === 0) return "checkout";
    if (path.indexOf("/pages/") === 0) return "content";
    return "site";
  }

  function conservativeMetaEventName(eventType) {
    eventType = clean(eventType, 80).toLowerCase();
    if (eventType === "page_view") return "PageView";
    if (eventType === "product_view" || eventType === "service_view" || eventType === "section_view" || eventType === "viewed_treatment" || eventType === "viewed_practitioner" || eventType === "review_engagement") return "ViewContent";
    if (eventType === "search") return "Search";
    if (eventType === "add_to_cart") return "AddToCart";
    if (eventType === "checkout" || eventType === "checkout_handoff") return "InitiateCheckout";
    if (eventType === "purchase") return "Purchase";
    if (eventType === "started_booking" || eventType === "booking_link_click" || eventType === "booking_step" || eventType === "selected_timeslot") return "Schedule";
    if (eventType === "lead" || eventType === "form_submit") return "Lead";
    return "DrSknnIntent";
  }

  function safeGa4EventName(eventType) {
    eventType = clean(eventType, 80).toLowerCase();
    if (eventType === "purchase") return "purchase";
    if (eventType === "form_submit") return "form_submit_attempt";
    if (eventType === "lead") return "lead_intent";
    if (eventType === "checkout" || eventType === "checkout_handoff") return "begin_checkout";
    if (eventType === "add_to_cart") return "add_to_cart";
    if (eventType === "product_view") return "view_item";
    if (eventType === "service_view" || eventType === "viewed_treatment") return "content_viewed";
    if (eventType === "started_booking" || eventType === "booking_link_click") return "booking_started";
    if (eventType === "booking_step") return "booking_step";
    if (eventType === "selected_timeslot") return "selected_timeslot";
    if (eventType === "price_list_viewed") return "price_list_viewed";
    if (eventType === "pricing_option_selected") return "pricing_option_selected";
    if (eventType === "service_family_viewed") return "service_family_viewed";
    if (eventType === "offer_viewed") return "offer_viewed";
    if (eventType === "offer_selected") return "offer_selected";
    if (eventType === "package_selected") return "package_selected";
    if (eventType === "subscription_interest") return "subscription_interest";
    return "";
  }

  function ga4EventParams(payload) {
    var params = {
      event_id: clean(payload.external_event_id, 120),
      send_to: "G-FC6YQ8SVMM",
      page_location: "https://drsknn.online/", page_path: "/",
      page_title: "Dr Sknn", page_referrer: "",
      page_group: routeGroup(payload.page_path),
      source_property: "drsknn.online"
    };
    if (payload.ecommerce && typeof payload.ecommerce.value === "number") params.value = payload.ecommerce.value;
    if (payload.ecommerce && payload.ecommerce.currency) params.currency = clean(payload.ecommerce.currency, 16);
    return params;
  }

  function platformTagsAvailable() {
    return Array.isArray(window.dataLayer) || typeof window.gtag === "function";
  }

  function emitPlatformEvent(payload) {
    var safe = {
      event_category: "drsknn_owned_site",
      event_name: conservativeMetaEventName(payload.event_type),
      interaction_type: clean(conservativeMetaEventName(payload.event_type).toLowerCase(), 80),
      page_group: routeGroup(payload.page_path),
      source_property: clean(payload.source_property, 255)
    };
    if (consentState().analytics_storage === "granted" && config.googleEvents && platformTagsAvailable()) {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: "drsknn_intent" }, safe));
      }
      if (typeof window.gtag === "function") {
        var ga4Name = safeGa4EventName(payload.event_type);
        if (ga4Name) window.gtag("event", ga4Name, ga4EventParams(payload));
        if (config.adIntentDetail) window.gtag("event", "drsknn_intent", ga4EventParams(payload));
      }
    }
    if (!marketingAllowed()) return;
    if (config.metaEvents && typeof window.fbq === "function") {
      window.fbq("trackCustom", "DrSknnIntent", safe, { eventID: payload.external_event_id });
    }
  }

  function track(eventType, extra, immediate) {
    if (!analyticsAllowed() && !marketingAllowed()) return;
    var payload = buildPayload(eventType, extra || {});
    sendToMarketingApp(payload, immediate);
    emitPlatformEvent(payload);
  }

  function trackOnce(eventType, extra, immediate) {
    var label = extra && extra.element ? extra.element.label || "" : "";
    var key = eventType + "|" + clean(label, 120) + "|" + window.location.href;
    var now = Date.now();
    if (state.lastActionKey === key && now - state.lastActionAt < 750) return;
    state.lastActionKey = key;
    state.lastActionAt = now;
    track(eventType, extra, immediate);
  }

  function trackVirtualPage(reason) {
    var key = pageKey();
    if (key === state.lastPageKey) return;
    state.lastPageKey = key;
    decorateAll(document);
    var intent = intentFromText(document.title, window.location.pathname + " " + window.location.search + " " + window.location.hash);
    track(pageEventType(intent), {
      intent: intent,
      element: { role: "virtual_page", label: clean(reason || "route_change", 80) }
    });
    captureSearchFromUrl();
  }

  function importantElement(target) {
    if (!target || !target.closest) return null;
    return target.closest([
      "a[href]",
      "button",
      "[role='button']",
      "input[type='submit']",
      "[onclick]",
      "[data-action]",
      "[data-tab]",
      "[data-tab-target]",
      "[data-treatment]",
      "[data-treatment-id]",
      "[data-treatment-name]",
      "[data-service]",
      "[data-service-id]",
      "[data-category]",
      "[data-concern]",
      "[data-condition]",
      "[data-slot]",
      "[data-timeslot]",
      "[data-time-slot]",
      ".kiosk-card",
      ".treatment-card",
      ".service-card",
      ".consultation-card",
      ".slot",
      ".time-slot",
      ".booking-slot",
      ".tab",
      ".pill",
      ".chip"
    ].join(", "));
  }

  function clickPayload(element) {
    var href = element && element.getAttribute ? element.getAttribute("href") : "";
    var url = null;
    try {
      url = href ? new URL(href, window.location.href) : null;
    } catch (e) {}
    var label = elementLabel(element);
    var dataText = datasetText(element);
    var combined = [label, href, dataText, element.className || ""].join(" ");
    var host = url ? url.hostname.toLowerCase() : "";
    var isOutbound = Boolean(url && host && host !== window.location.hostname.toLowerCase());
    var type = classifyInteraction(combined, url, host);
    return {
      type: type,
      element: {
        role: clean(element.tagName || "element", 80).toLowerCase(),
        label: label,
        href: href ? clean(decorateUrl(href), 1024) : "",
        outbound: isOutbound,
        booking: /booking|book|appointment|consult|checkout|pay|stripe|slot|time/i.test(type + " " + combined),
        dataset: clean(dataText, 500)
      },
      intent: intentFromText(combined, window.location.pathname)
    };
  }

  function trackSearch(query) {
    query = clean(query, 160);
    if (!query || /@|\d{5,}/.test(query)) return;
    track("search", {
      intent: Object.assign(intentFromText(query, window.location.pathname), { search_query: query })
    });
  }

  function captureSearchFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var query = params.get("q") || params.get("s") || params.get("search") || params.get("query");
      if (query) trackSearch(query);
    } catch (e) {}
  }

  function engagementPayload(finalEvent) {
    return {
      engagement: {
        duration_ms: Math.max(0, Date.now() - state.startedAt),
        max_scroll_percent: state.maxScroll,
        click_count: state.clickCount,
        final: Boolean(finalEvent)
      }
    };
  }

  function sendEngagement(finalEvent) {
    if (state.engagementSent && !finalEvent) return;
    state.engagementSent = true;
    track("engagement_summary", engagementPayload(finalEvent), Boolean(finalEvent));
  }

  function recordFriction(event, element, payload) {
    try {
      var now = Date.now();
      var x = Number(event.clientX || 0);
      var y = Number(event.clientY || 0);
      state.clickBurst = state.clickBurst.filter(function (item) {
        return now - item.t < 1500 && Math.abs(item.x - x) < 44 && Math.abs(item.y - y) < 44;
      });
      state.clickBurst.push({ x: x, y: y, t: now });
      if (state.clickBurst.length >= 3) {
        trackOnce("rage_click", {
          element: payload && payload.element ? payload.element : { role: "unknown", label: elementLabel(element) },
          intent: payload && payload.intent ? payload.intent : intentFromText(elementLabel(element), window.location.pathname),
          engagement: { click_x: x, click_y: y, click_count_window: state.clickBurst.length, window_ms: 1500 }
        }, true);
      }
    } catch (e) {}
  }

  function deadClickElement(target) {
    if (!target || !target.closest) return null;
    return target.closest([
      "[class*='card']",
      "[class*='tile']",
      "[class*='chip']",
      "[class*='pill']",
      "[class*='review']",
      "[class*='testimonial']",
      "[class*='practitioner']",
      "[class*='doctor']",
      "[class*='nurse']",
      "[class*='treatment']",
      "[class*='service']",
      "section",
      "article",
      "img"
    ].join(", "));
  }

  function trackDeadClick(event, target) {
    var node = deadClickElement(target);
    if (!node) return;
    var label = elementLabel(node);
    if (!label) return;
    var startKey = pageKey();
    window.setTimeout(function () {
      if (pageKey() !== startKey) return;
      trackOnce("dead_click", {
        element: { role: clean(node.tagName || "content", 80).toLowerCase(), label: label },
        intent: intentFromText(label, window.location.pathname),
        engagement: { click_x: Number(event.clientX || 0), click_y: Number(event.clientY || 0) }
      });
    }, 900);
  }

  function sectionIdentity(element) {
    if (!element || !element.getAttribute) return "";
    return clean(
      element.getAttribute("data-section")
        || element.getAttribute("data-drsknn-uni-section")
        || element.getAttribute("data-practitioner-id")
        || element.getAttribute("data-treatment-id")
        || element.getAttribute("id")
        || elementLabel(element)
        || element.className
        || "",
      180
    );
  }

  function sectionEventType(element, label) {
    var text = clean([label, element && element.className || "", datasetText(element)].join(" "), 500);
    if (/review|testimonial|rating|stars|result|case study/i.test(text)) return "review_engagement";
    if (/practitioner|doctor|nurse|clinician|therapist|team/i.test(text)) return "viewed_practitioner";
    if (/treatment|service|condition|concern|hydrafacial|botox|filler|laser|acne|pigment|peel|universkin/i.test(text)) return "viewed_treatment";
    return "section_view";
  }

  function observeContent(root) {
    try {
      if (!("IntersectionObserver" in window)) return;
      if (!state.sectionObserver) {
        state.sectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.55) return;
            var node = entry.target;
            var identity = sectionIdentity(node);
            if (!identity || state.viewedSections[identity]) return;
            state.viewedSections[identity] = true;
            var label = elementLabel(node) || identity;
            var eventType = sectionEventType(node, label);
            trackOnce(eventType, {
              element: { role: clean(node.tagName || "section", 80).toLowerCase(), label: clean(label, 220) },
              intent: intentFromText(label, window.location.pathname),
              engagement: { visible_ratio: Math.round(entry.intersectionRatio * 100), action: "section_visible" }
            });
          });
        }, { threshold: [0.55, 0.75] });
      }
      var scope = root && root.querySelectorAll ? root : document;
      var selector = [
        "section",
        "article",
        "[data-section]",
        "[data-drsknn-uni-section]",
        "[data-practitioner]",
        "[data-practitioner-id]",
        "[data-treatment]",
        "[data-treatment-id]",
        "[data-service]",
        "[class*='review']",
        "[class*='testimonial']",
        "[class*='practitioner']",
        "[class*='doctor']",
        "[class*='nurse']",
        "[class*='treatment-card']",
        "[class*='service-card']"
      ].join(", ");
      scope.querySelectorAll(selector).forEach(function (node) {
        var identity = sectionIdentity(node);
        if (identity && !state.viewedSections[identity]) state.sectionObserver.observe(node);
      });
    } catch (e) {}
  }

  function trackScrollMilestones() {
    [25, 50, 75, 90].forEach(function (milestone) {
      if (state.maxScroll >= milestone && !state.scrollMilestones[milestone]) {
        state.scrollMilestones[milestone] = true;
        trackOnce("scroll_milestone", {
          engagement: { scroll_percent: milestone, max_scroll_percent: state.maxScroll }
        });
      }
    });
  }

  function syncShopifyCartAttributes() {
    if (!config.cartAttributes || !isShopifyStorefrontHost(window.location.hostname)) return;
    if (!marketingAllowed()) return;
    var attribution = readStored();
    var attrs = {
      "attributes[drsknn_visitor_id]": visitorId(),
      "attributes[drsknn_session_id]": sessionId(),
      "attributes[drsknn_landing_url]": clean(attribution.landing_url || window.location.href, 500)
    };
    ATTR_KEYS.forEach(function (key) {
      if (attribution[key]) attrs["attributes[drsknn_" + key + "]"] = attribution[key];
    });
    try {
      var body = new URLSearchParams();
      Object.keys(attrs).forEach(function (key) {
        body.set(key, attrs[key]);
      });
      window.fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: body.toString()
      }).catch(function () {});
    } catch (e) {}
  }

  captureAttribution();
  visitorId();
  sessionId();
  window.addEventListener("drsknn:google-identity-ready", function () { decorateAll(document); });

  window.DRSKNN_ATTRIBUTION = {
    get: readStored,
    capture: captureAttribution,
    decorateUrl: decorateUrl,
    decorateAll: decorateAll,
    normalizeBookingLinks: normalizeBookingLinks,
    track: track
  };

  function initializePage() {
    decorateAll(document);
    observeContent(document);
    state.lastPageKey = pageKey();
    var initialIntent = intentFromText(document.title, window.location.pathname + " " + window.location.search + " " + window.location.hash);
    track(pageEventType(initialIntent), { intent: initialIntent });
    captureSearchFromUrl();
    syncShopifyCartAttributes();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializePage);
  } else {
    initializePage();
  }

  window.addEventListener("drsknn:consent-ready", function () {
    captureAttribution();
    decorateAll(document);
    if (window.DRSKNN_CONSENT_STATE && (window.DRSKNN_CONSENT_STATE.analytics || window.DRSKNN_CONSENT_STATE.marketing)) {
      state.lastPageKey = "";
      trackVirtualPage("consent_update");
    }
    syncShopifyCartAttributes();
  });

  document.addEventListener("click", function (event) {
    var element = importantElement(event.target);
    if (!element) {
      trackDeadClick(event, event.target);
      return;
    }
    if (handleLegacyBookingClick(event, element)) return;
    decorateElement(element, "href");
    state.clickCount += 1;
    var payload = clickPayload(element);
    recordFriction(event, element, payload);
    trackOnce(payload.type, { element: payload.element, intent: payload.intent });
    if (payload.element && payload.element.booking) {
      trackOnce("started_booking", { element: payload.element, intent: payload.intent });
      syncShopifyCartAttributes();
    }
    window.setTimeout(function () { trackVirtualPage("post_click"); }, 250);
  }, true);

  document.addEventListener("submit", function (event) {
    try {
      var form = event.target;
      var input = form && form.querySelector ? form.querySelector("input[type='search'], input[name='q'], input[name='s'], input[name='search'], input[name='query']") : null;
      if (input && input.value) trackSearch(input.value);
    } catch (e) {}
  }, true);

  document.addEventListener("change", function (event) {
    try {
      var target = event.target;
      if (!target || !isSafeIntentField(target)) return;
      var value = clean(target.value || target.options && target.options[target.selectedIndex] && target.options[target.selectedIndex].text || "", 160);
      if (!value) return;
      var field = safeFieldName(target);
      var intent = intentFromText(field + " " + value, window.location.pathname);
      var eventType = /slot|time|date/i.test(field) ? "selected_timeslot" : /search|query|filter/i.test(field) ? "search" : "viewed_treatment";
      var extra = {
        element: { role: clean(target.tagName || "field", 80).toLowerCase(), label: clean(field + ": " + value, 180) },
        intent: Object.assign(intent, /search|query|filter/i.test(field) ? { search_query: value } : {})
      };
      trackOnce(eventType, extra);
    } catch (e) {}
  }, true);

  document.addEventListener("focusin", function (event) {
    try {
      var target = event.target;
      if (!target || !/^(input|select|textarea)$/i.test(target.tagName || "")) return;
      var kind = fieldKind(target);
      trackOnce("form_progress", {
        element: { role: "field", label: kind },
        engagement: { action: "field_focus" }
      });
    } catch (e) {}
  }, true);

  document.addEventListener("input", function (event) {
    try {
      var target = event.target;
      if (!target || !isSafeIntentField(target)) return;
      var field = safeFieldName(target);
      if (!/search|query|filter/i.test(field)) return;
      window.clearTimeout(target.__drsknnSearchTimer);
      target.__drsknnSearchTimer = window.setTimeout(function () {
        trackSearch(target.value);
      }, 800);
    } catch (e) {}
  }, true);

  window.addEventListener("scroll", function () {
    try {
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop || 0;
      var height = Math.max(1, doc.scrollHeight - window.innerHeight);
      state.maxScroll = Math.max(state.maxScroll, Math.min(100, Math.round((scrollTop / height) * 100)));
      trackScrollMilestones();
    } catch (e) {}
  }, { passive: true });

  window.setTimeout(function () {
    sendEngagement(false);
  }, 15000);

  window.addEventListener("pagehide", function () {
    sendEngagement(true);
  });

  try {
    ["pushState", "replaceState"].forEach(function (method) {
      var original = history[method];
      if (typeof original !== "function") return;
      history[method] = function () {
        var result = original.apply(this, arguments);
        window.setTimeout(function () { trackVirtualPage(method); }, 0);
        return result;
      };
    });
    window.addEventListener("popstate", function () { trackVirtualPage("popstate"); });
    window.addEventListener("hashchange", function () { trackVirtualPage("hashchange"); });
  } catch (e) {}

  try {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "src") {
          decorateElement(mutation.target, "src");
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          decorateAll(node);
          observeContent(node);
          if (node.tagName && node.tagName.toLowerCase() === "iframe") decorateElement(node, "src");
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["src"] });
  } catch (e) {}
})();
